import React from "react"

const ItemsFlexWrapper = ({ children }) => {
  return <div className="flex flex-col gap-[1px]">{children}</div>
}

export default ItemsFlexWrapper
